import { useEffect, useState } from "react";

import { Order } from "@web-app/types";
import { isEarlyDeliveredOrder } from "@web-app/utils/helpers";

export function useEarlyDeliveryDetection({
  orderIds,
  orders,
  routedOrdersDraftEstimatedETA,
}: {
  orderIds?: string[];
  orders?: Map<string, Order>;
  routedOrdersDraftEstimatedETA?: Map<string, Date | null>;
}) {
  const [hasPotentialEarlyDeliveryOrders, setHasPotentialEarlyDeliveryOrders] =
    useState(false);

  useEffect(() => {
    let earlyDeliveryOrdersFound = false;

    if (routedOrdersDraftEstimatedETA && orders) {
      // For CreateRoute scenario - using draft eta
      for (const [orderId, etaDate] of routedOrdersDraftEstimatedETA) {
        earlyDeliveryOrdersFound = isEarlyDeliveredOrder(
          orders.get(orderId),
          etaDate,
        );
        if (earlyDeliveryOrdersFound) break;
      }
    } else if (orders && orderIds) {
      // For EditRoute scenario - using order eta
      for (const orderId of orderIds) {
        earlyDeliveryOrdersFound = isEarlyDeliveredOrder(orders.get(orderId));
        if (earlyDeliveryOrdersFound) break;
      }
    }

    setHasPotentialEarlyDeliveryOrders(earlyDeliveryOrdersFound);
  }, [orders, routedOrdersDraftEstimatedETA, orderIds]);

  return {
    hasPotentialEarlyDeliveryOrders,
  };
}
